<template>
  <span class="no-wrap">
    <slot></slot>
  </span>
</template>

<style scoped>
.no-wrap {
  white-space: nowrap;
}
</style>
